import React, { useState, useEffect } from 'react';
import Driver from 'packages/drivers';
import styles from './preview.module.scss';
import KoButton from 'packages/button';
import KoIcon from '@kwapio/icons';


const KoPreview = ({data, active}) => {

  const [activeIndex, setActiveIndex] = useState(active ? active : 0);

  useEffect(() => {
    setActiveIndex(active ? active : 0);
  }, [active]);
  const activeFile = data[activeIndex];
  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex + 1 >= data.length ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex - 1 < 0 ? data.length - 1 : prevIndex - 1
    );
  };

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };


  return (
    <div className={styles.carousel}>
      <div className={styles.carouselContent}>
        <KoButton className={`${styles.carouselBtn} ${styles.prev}`} onClick={handlePrev} iconBtn={true} icon={<KoIcon name='ArrowLeftOutlined' />} />
        <div className={styles.mediaPreview}>
          <Driver action={false} name={activeFile?.name} fileType={activeFile?.type} filePath={activeFile?.url} />
        </div>
        <KoButton className={`${styles.carouselBtn} ${styles.next}`} onClick={handleNext} iconBtn={true} icon={<KoIcon name='ArrowRightOutlined' />} />
      </div>
      <div className={styles.thumbnailContainer}>
        {data?.map((file, index) => (
          <div
            key={index}
            onClick={() => handleThumbnailClick(index)}
            className={`${styles.thumbnail} ${index === activeIndex ? styles.active : ''}`}>
            <Driver action={false} name={file?.name} fileType={file?.type} filePath={file?.url} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default KoPreview;
